module.exports = __webpack_public_path__ + "img/108hill-logo-revised.a06cee87.png";